import { logoutAdmin } from "../Redux/Auth/AuthActions";
import { logoutUser } from "../Redux/Auth/AuthActions";
import { store } from "../Redux/store";
import axios from "axios";

const UnauthorizedResponseInterceptor = (error: any) => {
  if (error.response?.status === 401) {
    const currentUrl = window.location.href;

    if (currentUrl.includes("/admin")) {
      store.dispatch(logoutAdmin());
    } else {
      store.dispatch(logoutUser());
    }
  }

  return Promise.reject(error);
};

const axiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => response,
    UnauthorizedResponseInterceptor,
  );
};

export default axiosInterceptors;
